// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Global CSS*/
.navigation h1,
.navigation h2,
.navigation h3,
.navigation h4,
.navigation h5,
.navigation h6 {
  text-decoration: none !important;
}

.list-group-item:hover {
  cursor: pointer;
}

.custom-control {
  width: 200%;
}

.custom-control-input:hover {
  cursor: pointer;
}

.custom-control-input:checked {
  background-color: #28a745;
  border-color: #28a745;
}

.custom-control-input:focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.card {
  background-color: #ffffff;
}

.bg-white{
  background-color: white;
}

.golden-badge {
  background-color: #cbae03 !important;
}

.dark-blue-badge {
  background-color: #045b87 !important;
}

.purple-badge {
  background-color: #282c49 !important;
}

.orange-badge {
  background-color: #ff6b6b !important;
}

.maroon-badge {
  background-color: #87042c !important;
}

.green-badge {
  background-color: #029c53 !important;
}

.label-style-text {
  margin-bottom: 8px;
  font-weight: 600;
  color: #0a0a0a;
  text-transform: uppercase;
}

.input-style-text {
  width: 197px;
}

.input-field-style {
  color: black !important;
  font-weight: 500;
}

/*Login Page CSS*/
.login {
  position: relative;
  margin: auto;
  padding-top: 8rem;
  /* top: 35px;
  left: 225px; */
}

.label_logo {
  font-size: 17px;
  font-weight: 800;
  text-align: center;
}

.login .signIn {
  border-radius: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
  height: 40px;
  width: 200px;
  margin-bottom: 5px;
}

.login .submit-div {
  /* margin-left: 100px */
  text-align: center;
}

@media screen and (max-width: 768px) {
  .login {
    position: absolute;
    margin: auto;
  }

  .login .submit-div {
    /* margin-left: 50px */
    text-align: center;
  }
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
  .login {
    position: relative;
    margin: auto;
  }

  .login .submit-div {
    margin-left: 50px;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1366px) {
  .card_new_For_feeReport {
    border: 1px solid #929baa26;
    border-radius: 10px;
    opacity: 1;
    margin: auto;
    height: 105px;
    width: 80px;
  }

  .payable_heading_feeReport {
    text-align: center;
    font: normal normal 8px/10px Montserrat;
    letter-spacing: 0px;
    color: white;
    /* color: #DDDDDD; */
    opacity: 1;
  }

  .amount_fee_feeReport {
    text-align: center;
    font: normal normal 600 10px/12px Montserrat;
    letter-spacing: 0px;
    color: #ffffff;
    opacity: 1;
  }

  .months_Name_Report {
    text-align: center;
    font: normal normal 650 9px/10px Montserrat;
    letter-spacing: 0px;
    color: #ffffff;
    opacity: 1;
  }

  .content_feeReport {
    position: absolute;
    top: 4px;
  }

  .widthForTheTR {
    width: 8rem;
  }

  .penality_appliad_and_items {
    color: #0a0a0a;
    font: normal normal 700 8px/9px Montserrat;
  }

  .penality_appliad_items {
    color: #0a0a0a;
    font: normal normal 700 11px/13px Montserrat;
  }
}

@media screen and (min-width: 1367px) and (max-width: 1920px) {
  .card_new_For_feeReport {
    border: 1px solid #929baa26;
    border-radius: 10px;
    opacity: 1;
    margin: auto;
    height: 120px;
    width: 121px;
  }

  .months_Name_Report {
    text-align: center;
    font: normal normal medium 14px/18px Montserrat;
    letter-spacing: 0px;
    color: #ffffff;
    opacity: 1;
  }

  .content_feeReport {
    position: absolute;
    top: 4px;
  }

  .widthForTheTR {
    width: 12rem;
  }

  .amount_fee_feeReport {
    text-align: center;
    font: normal normal 600 12px/15px Montserrat;
    letter-spacing: 0px;
    color: #ffffff;
    opacity: 1;
  }

  .payable_heading_feeReport {
    text-align: center;
    font: normal 10px/12px Montserrat;
    letter-spacing: 0px;
    color: white;
    opacity: 1;
  }

  .penality_appliad_and_items {
    color: #0a0a0a;
    font: normal normal 700 12px/14px Montserrat;
  }

  .penality_appliad_items {
    color: #0a0a0a;
    font: normal normal 700 13px/15px Montserrat;
  }
}

/**/
.card-setting:hover {
  background: red;
  color: grey;
}

.rt-td {
  overflow: visible;
}

.button-resize {
  margin-right: 3%;
  width: 25px;
  height: 25px;
}

.right-border {
  border-right: 1px solid #ddd;
}

.card-setting {
  width: 100%;
  height: 100px;
  color: white;
  cursor: pointer;
}

.student-info .container {
  position: relative;
}

.student-info .container img {
  display: block;
  position: relative;
  border-radius: 50%;
  background-color: red;
}

.student-info .container .fonticon-wrap {
  position: absolute;
  bottom: 35px;
  left: 180px;
  background-color: black;
  border-radius: 50%;
  border: 1px white;
  padding: 10px;
}

.school-info-account .table {
  font-size: 16px;
}

.school-info-account .table .thead tr th {
  color: #af8eb5;
  font-size: 16px;
  font-weight: bold;
  padding-top: 10px;
}

.school-info-account .table tr th {
  color: #7e57c2;
  font-size: 16px;
}

.subadmin-btn {
  background-color: red;
  color: white;
  width: 250px;
  margin-top: 10px;
}

.subadmin-btn:hover {
  background-color: red;
  color: white;
}

.my-custom-scrollbar {
  position: relative;
  height: 200px;
  overflow-y: scroll;
}

.table-wrapper-scroll-y {
  display: block;
}

.calender-card {
  height: 35px;
}

.calender-time-input {
  padding-top: 20px;
  text-align: right;
  float: right;
  align-items: right;
}

.Calender-input {
  width: 48px;
  border: none;
  margin-right: 50px;
}

.Calender-input:active {
  border: none;
}

.Calender-input:hover {
  border: none;
}

.Calender-input:visited {
  border: none;
}

.Organisation {
  background-color: #e5e8e8;
  color: #273746;
  margin-top: 10px;
  margin-left: 5px;
  height: 100px;
}

.Organisation-p {
  text-align: left;
  padding-left: 20px;
  padding-top: 20px;
  align-items: center;
}

.Organisation2 {
  background-color: #e5e8e8;
  color: #273746;
  height: 100px;
  width: 350px;
}

.Organisation-p2 {
  text-align: left;
  padding-left: 20px;
  padding-top: 20px;
  align-items: center;
}

/* .tabs-Report{
        display: block;
        align-items: center;
        text-align: center;
    } */
.navitem-report {
  border: 2px solid red;
}

.Reset-password-card {
  align-items: center;
  text-align: center;
  padding: 11.6%;
  background-color: lavender;
}

.Reset-img {
  margin-top: 12%;
  width: 40%;
  height: auto;
}

.login-btn {
  width: 150px;
  text-align: center;
  font-size: 13px;
}

.Forgot-password-card {
  align-items: center;
  text-align: center;
  padding: 16.5%;
  background-color: lavender;
}

.forgot-img {
  margin-top: 5%;
  width: 50%;
  height: auto;
}

.Luxert-Icon {
  margin-top: 20px;
}

.More-Card:hover {
  cursor: pointer;
}

.dashboard-item-icon {
  margin-top: 10px;
  width: 45px;
  height: auto;
}

.Pending-text {
  margin-right: -10px;
}

@media (max-width: 1460px) {
  .dashboard-item-col {
    display: inline-block;
    justify-content: center;
    margin-left: 50px;
    margin-bottom: 10px;
  }
}

.heading_school {
  color: black;
  font-size: 30px;
  font-weight: bold;
  font-family: "Montserrat", sans-serif;
}

.branch_school {
  font-size: 15px;
  color: white;
  font-family: "Montserrat", sans-serif;
}

.DashBoardCard {
  font-family: "Montserrat", sans-serif;
  width: 100%;
  text-align: center;
  color: black;
  /* background-color: #7367f0; */
}

.-improve {
  font-family: "Montserrat", sans-serif;
  padding: 1rem;
}

.TransportSubAdmin {
  font-family: "Montserrat", sans-serif;
  padding-top: 2%;
  margin: auto;
  font-size: 18px;
}

.download-teacher-assest {
  width: 50px;
  height: 50px;
}

.teacher-text {
  font-size: 12px;
  font-weight: 500;
}

.Badge-document {
  width: 150px;
}

.Nav-emergency {
  margin-top: 10px;
}

.Structure {
  text-align: center;
}

.Teacher-sections {
  justify-content: space-between;
}

.Badge-Badge-ClassCard {
  width: 90px;
  height: 25px;
  padding-top: 8px;
  background-color: #cdd47b;
}

.Schedule-View {
  width: 200px;
  margin: auto;
  display: inline-flex;
  text-align: center;
}

.Schedule-month {
  text-align: center;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
}

.Schedule-mo {
  padding-top: 1rem;
  margin: auto;
  text-align: center;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
}

.Category-General {
  float: right;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
}

.Category-Structure-Name {
  float: left;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
}

.Schedule-Session {
  margin: auto;
  text-align: center;
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
}

.Promote-Acdemic {
  font-size: 14px;
  /* text-align: center; */
  /* margin-left: 25px; */
}

.Promote {
  font-size: 15px;
  height: 2.5rem;
  width: 6rem;
  text-align: center;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
}

.admission_buttons {
  height: 38px;
  padding-top: 12px;
  color: white;
  width: 140px;
  border: none;
}

.carryforward_button {
  height: 38px;
  padding-top: 12px;
  color: white;
  width: 110px;
  border: none;
}

.admission_buttons_Communication {
  height: 38px;
  padding: 12px;
  color: white;
  width: auto;
  border: none;
}

.clientDataStudentButon {
  height: 37px;
  padding-top: 12px;
  font-size: medium;
  color: white;
  width: 90px;
  border: none;
}

.BackGround_Print {
  background-color: white;
}

.feePayment_CardHeader {
  width: 21.8em;
  padding-top: 2px;
  font-family: normal normal 600 14px/18px Montserrat;
  letter-spacing: 0px;
  border-radius: 10px 10px 0 0;
  /* color: #FFFFFF; */
  text-align: center;
  color: white;
  padding-bottom: 5px;
}

.feePayment_Footter {
  width: 100%;
  margin-bottom: 0;
  padding-top: 2px;
  font-family: normal normal 600 14px/18px Montserrat;
  letter-spacing: 0px;
  border-radius: 0 0 10px 10px;
  /* color: #FFFFFF; */
  text-align: center;
  color: white;
  padding-bottom: 5px;
}

.FeeAmount {
  text-align: right;
  font: normal 14px/16px Montserrat;
  letter-spacing: 0px;
  font-weight: bolder;
  margin-top: 0.3rem;
  margin-right: 0.5rem;
  color: #000000;
  opacity: 1;
}

.FeeText {
  text-align: left;
  font: normal 14px/18px Montserrat;
  letter-spacing: 0px;
  margin-top: 0.3rem;
  margin-left: 0.5rem;
  font-weight: bold;
  color: #707070;
  opacity: 1;
}

.feePayment_Cards {
  border-radius: 10px;
  border: 3px solid red;
  background-color: #f7f7f7;
  margin: auto;
  box-sizing: border-box;
  border: 1px solid #929baa26;
  /* align-items: center; */
  box-shadow: 0px 5px 15px #00000014;
  opacity: 1;
  justify-self: center;
  justify-content: center;
}

.AmountCollectedCard {
  background-color: #11242c;
  color: white;
  text-align: center;
  height: 80px;
  padding-top: 2rem;
  padding-bottom: 2rem;
  border-radius: 1rem;
}

.cashdateRange {
  background-color: green;
  color: white;
}

.chequedateRange {
  background-color: purple;
  color: white;
}

.bankdateRange {
  background-color: skyblue;
  color: white;
}

.onlinedateRange {
  background-color: orange;
  color: white;
}

.ChequeCollection {
  font-size: x-small;
  text-align: center;
}

.MinimumDueAmount {
  width: 150px;
  margin: auto;
  border-radius: 20px;
  height: calc(1.66rem + 1px) !important;
  font-size: 0.675rem;
}

.monthSelect {
  width: 150px;
  align-items: right;
  /* margin-right:5px ; */
  border-radius: 20px;
  height: calc(1.86rem + 12px) !important;
  font-size: 1rem;
}

.glow_border {
  background-color: black;
}

/* .glow {
  font-size: 20px;
  color: #fff;
  text-align: center;
  -webkit-animation: glow 1s ease-in-out infinite alternate;
  -moz-animation: glow 1s ease-in-out infinite alternate;
  animation: glow 1s ease-in-out infinite alternate;
}

@-webkit-keyframes glow {
  from {
    text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #e60073, 0 0 40px #e60073, 0 0 50px #e60073, 0 0 60px #e60073, 0 0 70px #e60073;
  }

  to {
    text-shadow: 0 0 20px #fff, 0 0 30px #ff4da6, 0 0 40px #ff4da6, 0 0 50px #ff4da6, 0 0 60px #ff4da6, 0 0 70px #ff4da6, 0 0 80px #ff4da6;
  }
} */

.AddExam_Periodic {
  background: burlywood;
}

.Table_Header {
  text-align: center;
  margin-top: 3em;
}

.Teacher_Attendance_Report {
  text-align: center;
  margin-left: 20rem;
}

.Teacher_Attendance_Report_text {
  font-size: 2rem;
}

.Teacher_Attendance_Card_Report {
  color: #7e57c2;
}

.Employee_OutTime {
  width: 30rem;
}

.Result_List {
  padding-top: 1em;
  border-radius: 8%;
  padding-left: 1em;
  width: 10em;
  box-shadow: floralwhite 5px 5px 5px 5px;
}

.studentTableSubject {
  align-items: center;
  text-align: center;
}

.StudentTable {
  background-color: #7367f0;
  color: white;
}

.promotestudentTable {
  align-items: center;
  color: "#0A0A0A";
  font-weight: 800;
  text-align: center;
}

.pdf_header {
  text-align: center;
  align-items: center;
}

.pdf_fontFamily {
  font-family: Georgia, "Times New Roman", Times, serif;
}

.printComponent {
  font-family: "Montserrat", sans-serif;
  font-size: medium;
  font-weight: 500;
  text-transform: uppercase;
  margin-top: 5rem;
  text-align: center;
}

.my-Promote-Student {
  position: relative;
  height: 400px;
  overflow-y: scroll;
}

.DailyReportTable {
  position: relative;
  height: 380px;
  overflow-y: scroll;
  text-align: center;
}

.incomeTableHandling {
  position: relative;
  height: 200px;
  overflow-y: scroll;
  text-align: center;
}

.ExpenditureTableHandling {
  position: relative;
  height: 270px;
  overflow-y: scroll;
  text-align: center;
}

.leaveMangementclassDailyReport {
  position: relative;
  height: 280px;
  overflow-y: scroll;
  text-align: cent;
}

.classBulkAttendanceTable {
  position: relative;
  /* height: 380px; */
  overflow-x: scroll;
  text-align: center;
}

.table-Promote {
  display: block;
}

/* ------------ template css  ------------*/

.template-row {
  padding: 120px 0px;
  margin: auto;
  justify-content: center;
  text-align: center;
  font-size: 30px;
  color: #000000;
  font-weight: 700;
  font-family: Montserrat, sans-serif;
}

.template {
  box-shadow: 10px 10px 10px 10px #f5f5f5;
  margin: auto;
  width: 1000px;
  margin-bottom: 100px;
}

.tempalte-image {
  width: 150px;
}

.template-button {
  margin-bottom: 20px;
  background-color: #3acce1;
  width: 450px;
  border-radius: 7px;
  border: none;
}

.template-button:hover {
  background-color: #3acce1;
}

.template-body h4 {
  color: #ff0000;
  font-weight: 700;
}

.template-buttonTwo {
  background-color: #cacaca;
  width: 450px;
  border-radius: 7px;
  border: none;
}

.template-buttonTwo:hover {
  background-color: #cacaca;
}

.tempalte-p {
  margin-top: 10px;
  font-size: 10px;
  color: #0e172c;
}

.template-h6 {
  font-size: 15px;
  margin-bottom: 15px;
}

.lock-template {
  margin-right: 5px;
  width: 8px;
  height: 12px;
}

.paymentImage {
  margin: auto;
  text-align: center;
}

.paymentcol {
  margin: auto;
  text-align: center;
}

/* Employee_List */

.Employee_List {
  margin-left: 5rem;
}

/* dashboard subaadmin */

.divider {
  border-left: 2px solid #e3e3e3;
  opacity: 1;
  height: 90px;
  margin: auto;
}

.card_img_new {
  margin-left: 1.4rem;
  margin-top: 0.5rem;
  width: 55px;
  height: 57px;
}

.amount {
  text-align: center;
  font: normal normal 600 18px/22px Montserrat;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}

.text_card_sub {
  text-align: center;
  font: normal normal medium 12px/16px Montserrat;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}

.amount_text_Col_Subadmin {
  margin: auto;
  padding: auto;
}

.card_sunadmin_dashboard {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 10px 10px #00000029;
  border-radius: 10px;
  opacity: 1;
  text-align: center;
  justify-content: center;
}

.label_card_subadmin {
  text-align: center;
  font: normal normal 500 12px/16px Montserrat;
  letter-spacing: 0.5px;
  opacity: 1;
  margin-right: -2.7rem;
  margin-top: 0.5rem;
}

/* side table --start  */

.UpComingExam_SubAdmin {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 10px;
  opacity: 1;
  height: 18.5rem;
}

.upcoming_exam_table {
  background: #7164ff 0% 0% no-repeat padding-box;
  border-radius: 10px 10px 0px 0px;
  opacity: 1;
  margin: auto;
  font: normal normal 600 20px/24px Montserrat;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  height: 3.5rem;
}

.table_header_upcoming {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  opacity: 1;
}

.table_text {
  text-align: center;
  font: normal normal 600 14px/18px Montserrat;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}

.table_body_upcoming {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 1px 20px #00000017;
  border: 1px solid #e2e2e2;
  border-radius: 10px;
  opacity: 1;
}

.table_body_text {
  text-align: center;
  font: normal normal medium 14px/18px Montserrat;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}

/* side table --end */

/* reponsive ----css */
@media (max-width: 1460px) {
  .card_img_new {
    margin-left: 1.4rem;
    margin-top: 0.5rem;
    width: 35px;
    height: 37px;
  }

  .amount {
    text-align: center;
    font: normal normal 600 12px/15px Montserrat;
    letter-spacing: 0px;
    margin-left: 2rem;
    color: #000000;
    opacity: 1;
  }

  .divider {
    border-left: 2px solid #e3e3e3;
    opacity: 1;
    height: 70px;
    margin: auto;
  }

  .text_card_sub {
    text-align: center;
    font: normal normal 500 12px/16px Montserrat;
    letter-spacing: 0px;
    color: #000000;
    margin-left: 2rem;
    opacity: 1;
  }

  .label_card_subadmin {
    text-align: center;
    font: normal normal 500 10px/14px Montserrat;
    letter-spacing: 0.5px;
    opacity: 1;
    margin-right: -2.7rem;
    margin-top: 0.5rem;
  }
}

@media (max-width: 1000px) {
  .divider {
    display: none;
  }

  .text_card_sub {
    text-align: center;
    font: normal normal 500 14px/20px Montserrat;
    letter-spacing: 0px;
    color: #000000;
    margin-left: 5rem;
    opacity: 1;
  }

  .amount {
    text-align: center;
    font: normal normal 600 17px/24px Montserrat;
    letter-spacing: 0px;
    margin-left: 5rem;
    margin-top: 2rem;
    color: #000000;
    opacity: 1;
  }

  .card_img_new {
    margin-left: 1.4rem;
    margin-top: 0.5rem;
    width: 55px;
    height: 57px;
  }

  .label_card_subadmin {
    text-align: center;
    font: normal normal 500 14px/20px Montserrat;
    letter-spacing: 0.5px;
    opacity: 1;
    margin-right: -2.7rem;
    margin-top: 0.5rem;
  }
}

.table_heading {
  text-align: center;
  color: black;
}

/* lef hand css == -= -=-=  */
.report_schoolName {
  font-size: 18px;
  font-weight: 900;
  font-family: "Montserrat", sans-serif;
}

.reportSchoolName {
  font-size: 27px;
  font-weight: 900;
  font-family: "Montserrat", sans-serif;
}

.STUDENTREPORTSCHOOLNAME {
  font-size: 30px;
  font-weight: 900;
  font-family: "Montserrat", sans-serif;
}

.schoolCode {
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  font-family: "Montserrat", sans-serif;
}

.SCHOOLCODE {
  text-align: right;
  font-size: 27px;
  font-weight: 600;
  font-family: "Montserrat", sans-serif;
}

.reportSchoolCde {
  text-align: right;
  font-size: 22px;
  font-weight: 600;
  font-family: "Montserrat", sans-serif;
}

.relativeCSS {
  border: solid 1px #ff0000;
  padding: "2rem";
  margin-left: "2rem";
  margin-right: "2rem";
}

.affiliationNo {
  text-align: right;
  font-size: 16px;
  font-weight: 900;
  font-family: "Montserrat", sans-serif;
}

.AFFLICATIONREPORTSTUDENT {
  text-align: right;
  font-size: 30px;
  font-weight: 900;
  font-family: "Montserrat", sans-serif;
}

.studentAffiliationNo {
  text-align: right;
  font-size: 22px;
  font-weight: 900;
  font-family: "Montserrat", sans-serif;
}

.report_Tag {
  font-size: 14px;
  font-weight: 600;
  font-family: "Montserrat", sans-serif;
}

.REPORTTAG {
  font-size: 27px;
  font-weight: 600;
  font-family: "Montserrat", sans-serif;
}

.branchNameReport {
  font-size: 22px;
  font-weight: 600;
  font-family: "Montserrat", sans-serif;
}

.report_Address {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.1rem;
  font-family: "Montserrat", sans-serif;
  color: #000000;
}

.REPORTADRESSS {
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.1rem;
  font-family: "Montserrat", sans-serif;
  color: #000000;
}

.addressReportStudent {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.1rem;
  font-family: "Montserrat", sans-serif;
  color: #000000;
}

.report_Branch {
  font-size: 14px;
  font-weight: 900;
  font-family: "Montserrat", sans-serif;
  color: #312a2a;
}

.REPORTbRANCCH {
  font-size: 24px;
  font-weight: 900;
  font-family: "Montserrat", sans-serif;
  color: #312a2a;
}

/* ------------------------ */
.modal_item_alignment {
  font-family: "Montserrat", sans-serif;
  font-size: 30px;
  font-weight: 600;
  text-align: center;
  margin: auto;
  align-items: center;
  justify-content: center;
}

.modal_item {
  font-family: "Montserrat", sans-serif;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  margin: auto;
  align-items: center;
  justify-content: center;
}

/* end dashboard */

.feeRecipt_Admission_Student {
  font-size: 14px;
  color: black;
  font-weight: 500;
}

.feeRecipt_Admission_stuNumber {
  font-size: 14px;
  color: black;
  font-weight: 500;
}

.TooltipAlignMent {
  text-align: right;
  margin-right: 1rem;
  height: auto;
  width: auto;
}

.vertical_line_between {
  border-left: 2px solid black;
  height: 25px;
  position: absolute;
  left: 50%;
}

.table_student_report {
  border-radius: 10px 10px;
}

/* time -table - ui section  */
.time_table_daysPeriods {
  background: rgb(157, 150, 150) 0% 0% no-repeat padding-box;
  border-radius: 3px;
  /* opacity: 0.2; */
}

.days_text_timeTable {
  text-align: center;
  font: normal normal 600 12px/14px Montserrat;
  letter-spacing: 0px;
  color: white;
  /* opacity: ; */
}

.time_table_periodTime {
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 3px;
  opacity: 1;
  padding-top: 15px;
  width: 100%;
  height: 50px;
}

.time_table_subject {
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 3px;
  opacity: 1;
  width: auto;
  padding-top: 5px;
  padding-left: 9px;
  height: 70px;
  text-align: left;
}

.time_table_Crole {
  position: relative;
  overflow-x: scroll;
}

.subjectTimeTable {
  text-align: left;
  font: normal normal 600 12px/14px Montserrat;
  letter-spacing: 0px;
  color: white;
  opacity: 1;
}

.timetableBreakTime {
  background: #f8f8f8 0% 0% no-repeat padding-box;
  color: white;
  /* opacity: 1; */
}

.timeTableBreak {
  background: rgb(179, 169, 169) 0% 0% no-repeat padding-box;
  border-radius: 3px;
  color: white;
  /* opacity: 0.2; */
}

.breaktimetableText {
  text-align: center;
  font: normal normal 600 12px/14px Montserrat;
  letter-spacing: 0px;
  color: white;
  opacity: 1;
}

.timeTableAssembly {
  background: #f8f8f8 0% 0% no-repeat padding-box;
  /* opacity: 1; */
}

.assTimeTable {
  background: rgb(139, 135, 135) 0% 0% no-repeat padding-box;
  border-radius: 3px;
  /* opacity: 0.2; */
}

.assmTimeTableText {
  text-align: left;
  font: normal normal 600 12px/14px Montserrat;
  letter-spacing: 0px;
  color: white;
  /* opacity: 1; */
}

.AddTIMETABLEDAYS {
  background: rgb(184, 175, 175) 0% 0% no-repeat padding-box;
  border-radius: 3px;
  text-align: center;
  /* opacity: 0.2; */
}

.ADDTIMETABLEPERIODSDAYS {
  text-align: center;
  font: normal normal 600 12px/14px Montserrat;
  letter-spacing: 0px;
  color: white;
  /* opacity: 1; */
}

.AssemblyTime {
  background: #f5f5f5 0% 0% no-repeat padding-box;
  /* opacity: 1; */
}

.AssemblyText {
  text-align: center;
  font: normal normal 600 12px/14px Montserrat;
  letter-spacing: 0px;
  color: white;
  /* opacity: 1; */
}

.AssemblyTextBackground {
  background: rgb(165, 157, 157) 0% 0% no-repeat padding-box;
  border-radius: 3px;
  /* opacity: 0.2; */
}

.periodTime {
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 3px;
  text-align: center;
  padding-top: 15px;
  width: auto;
  height: 50px;
}

/* time - table - ui section end  */

/* new one Extre */

.ExpnedutureCard {
  font-size: 10px;
  color: white;
  background-color: #012d47;
  color: white;
  text-align: center;
  font-weight: 900;
  text-transform: uppercase;
}

.studentInfoTOOLSpATENT {
  font: normal normal 700 12px/14px Montserrat;
  color: #0a0a0a;
}

.cardForPaymentList {
  width: 100%;
  height: auto;
  border-radius: 1rem;
  margin: 1rem;
  color: white;
  font: normal normal 700 14px/16px Montserrat;
  padding: 2.5rem;
  align-items: center;
  text-align: center;
}

.cardForPaymentList_card {
  width: 100%;
  height: 2.6rem;
  border-radius: 1rem;
  margin: 0.5rem;
  margin-top: 0.9rem;
  margin-left: 1.3rem;
  color: white;
  font: normal normal 700 12px/16px Montserrat;
  padding: 0.9rem;
  align-items: center;
  text-align: center;
}

.button_spacial {
  width: 12rem;
  height: 4.9rem;
}

.Registration_report_cards {
  height: 100%;
  width: 100%;
  border-radius: 1rem;
  font: normal normal 700 12px/16px Montserrat;
  text-align: center;
  padding-top: 2.6rem;
  padding-bottom: 2rem;
}

.Regis_report_card {
  height: 2.6rem;
  width: 100%;
  border-radius: 1rem;
  font: normal normal 700 10px/12px Montserrat;
  text-align: center;
  padding-top: 1rem;
  margin-top: 0.5rem;
  padding-bottom: 2rem;
}

.paymentModalClassForChange {
  font-family: "Montserrat", sans-serif;
  font-size: 30px;
  font-weight: 600;
  text-align: center;
  margin: auto;
  align-items: center;
  justify-content: center;
}

.paymentMessageFromProps {
  font-family: "Montserrat", sans-serif;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  margin: auto;
  align-items: center;
  justify-content: center;
}

.finalModalClassForChange {
  font-family: "Montserrat", sans-serif;
  font-size: 30px;
  font-weight: 600;
  text-align: center;
  margin: auto;
  align-items: center;
  justify-content: center;
}

.finalClassForChange {
  font-family: "Montserrat", sans-serif;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin: auto;
  align-items: center;
  justify-content: center;
}

.custom-calendar {
  /* Custom styles for the calendar */
  .react-calendar.react-calendar--border {
    border: none !important;
    /* Remove border */
  }

  /* Increase font size and weight of the month */
  .react-calendar__navigation__label {
    font-size: 18px;
    font-weight: bold;
    color: purple !important;
  }

  /* Custom styles for react-calendar */
  .react-calendar {
    /* Remove border */
    border: none;
  }

  /* Increase font size and weight for calendar dates */
  .react-calendar__month-view__days__day {
    font-size: 15px;
    font-weight: 700;
    text-decoration: none;
  }

  .react-calendar__month-view__weekdays__weekday {
    font-size: 13px;
    font-weight: bold;
    text-decoration: none !important;
    color: black !important;
  }

  /* Remove default border styles for all tiles */
  .react-calendar__tile {
    border: none !important;
  }

  /* Responsive styles */
}

@media (max-width: 768px) {
  .custom-calendar {
    width: 100%;
  }
}

.transport-fee-button {
  font-size: 1.2rem;
  height: 2.5rem;
  background-color: red;
  text-align: center;
  width: auto; /* Allow width to adjust based on content */
  min-width: 30%; /* Minimum width */
  margin-left: 1em;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.5em; /* Adjust padding to manage space */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: width 0.2s ease, font-size 0.2s ease; /* Smooth transition for width and font-size */
}

.transport-fee-button .bus-image {
  width: auto;
  height: 100%;
  margin-right: 0.5em; /* Add some space between image and text */
}

.transport-fee-button .transport-fee-text {
  flex: 1 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
}

@media (max-width: 1200px) {
  .transport-fee-button {
    font-size: 1rem; /* Decrease font size for smaller screens */
  }
}

@media (max-width: 992px) {
  .transport-fee-button {
    font-size: 0.9rem; /* Further decrease font size for smaller screens */
  }
}

@media (max-width: 768px) {
  .transport-fee-button {
    font-size: 0.8rem; /* Further decrease font size for smaller screens */
    width: 80%; /* Adjust width to be more flexible */
  }
}

@media (max-width: 576px) {
  .transport-fee-button {
    font-size: 0.7rem; /* Further decrease font size for smallest screens */
    width: 100%; /* Full width for smallest screens */
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/app.css"],"names":[],"mappings":"AAAA,aAAa;AACb;;;;;;EAME,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB;gBACc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,uCAAuC;IACvC,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,4CAA4C;IAC5C,mBAAmB;IACnB,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,0CAA0C;EAC5C;;EAEA;IACE,cAAc;IACd,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,+CAA+C;IAC/C,mBAAmB;IACnB,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,4CAA4C;IAC5C,mBAAmB;IACnB,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,iCAAiC;IACjC,mBAAmB;IACnB,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,4CAA4C;EAC9C;;EAEA;IACE,cAAc;IACd,4CAA4C;EAC9C;AACF;;AAEA,GAAG;AACH;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;;OAIO;AACP;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,qBAAqB;IACrB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mDAAmD;EACnD,mBAAmB;EACnB,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mDAAmD;EACnD,mBAAmB;EACnB,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;EACzB,kCAAkC;EAClC,UAAU;EACV,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;;;;;;GAiBG;;AAEH;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,2CAA2C;;AAE3C;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,kBAAkB;;AAElB;EACE,iBAAiB;AACnB;;AAEA,wBAAwB;;AAExB;EACE,8BAA8B;EAC9B,UAAU;EACV,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,+CAA+C;EAC/C,mCAAmC;EACnC,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,qBAAqB;EACrB,UAAU;EACV,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,wBAAwB;;AAExB;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,gCAAgC;EAChC,UAAU;EACV,YAAY;EACZ,4CAA4C;EAC5C,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,+CAA+C;EAC/C,kCAAkC;EAClC,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;;AAEA,qBAAqB;;AAErB,sBAAsB;AACtB;EACE;IACE,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,4CAA4C;IAC5C,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,8BAA8B;IAC9B,UAAU;IACV,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,4CAA4C;IAC5C,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,4CAA4C;IAC5C,qBAAqB;IACrB,UAAU;IACV,qBAAqB;IACrB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,4CAA4C;IAC5C,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,4CAA4C;IAC5C,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,4CAA4C;IAC5C,qBAAqB;IACrB,UAAU;IACV,qBAAqB;IACrB,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kBAAkB;;AAElB;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B;EACE,0DAA0D;EAC1D,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,+CAA+C;EAC/C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,0DAA0D;EAC1D,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,0DAA0D;EAC1D,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,0DAA0D;EAC1D,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,0DAA0D;EAC1D,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA,mCAAmC;;AAEnC,kBAAkB;;AAElB;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,4CAA4C;EAC5C,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;EAC5C,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA,+CAA+C;EAC/C;IACE,eAAe;IACf,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA,qCAAqC;EACrC;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA,qDAAqD;EACrD;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gCAAgC;IAChC,uBAAuB;EACzB;;EAEA,+CAA+C;EAC/C;IACE,uBAAuB;EACzB;;EAEA,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,WAAW,EAAE,2CAA2C;EACxD,cAAc,EAAE,kBAAkB;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB,EAAE,mCAAmC;EACrD,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD,EAAE,8CAA8C;AAClG;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAE,0CAA0C;AACjE;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe,EAAE,2CAA2C;EAC9D;AACF;;AAEA;EACE;IACE,iBAAiB,EAAE,mDAAmD;EACxE;AACF;;AAEA;EACE;IACE,iBAAiB,EAAE,mDAAmD;IACtE,UAAU,EAAE,qCAAqC;EACnD;AACF;;AAEA;EACE;IACE,iBAAiB,EAAE,oDAAoD;IACvE,WAAW,EAAE,oCAAoC;EACnD;AACF","sourcesContent":["/*Global CSS*/\n.navigation h1,\n.navigation h2,\n.navigation h3,\n.navigation h4,\n.navigation h5,\n.navigation h6 {\n  text-decoration: none !important;\n}\n\n.list-group-item:hover {\n  cursor: pointer;\n}\n\n.custom-control {\n  width: 200%;\n}\n\n.custom-control-input:hover {\n  cursor: pointer;\n}\n\n.custom-control-input:checked {\n  background-color: #28a745;\n  border-color: #28a745;\n}\n\n.custom-control-input:focus {\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n\n.card {\n  background-color: #ffffff;\n}\n\n.bg-white{\n  background-color: white;\n}\n\n.golden-badge {\n  background-color: #cbae03 !important;\n}\n\n.dark-blue-badge {\n  background-color: #045b87 !important;\n}\n\n.purple-badge {\n  background-color: #282c49 !important;\n}\n\n.orange-badge {\n  background-color: #ff6b6b !important;\n}\n\n.maroon-badge {\n  background-color: #87042c !important;\n}\n\n.green-badge {\n  background-color: #029c53 !important;\n}\n\n.label-style-text {\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #0a0a0a;\n  text-transform: uppercase;\n}\n\n.input-style-text {\n  width: 197px;\n}\n\n.input-field-style {\n  color: black !important;\n  font-weight: 500;\n}\n\n/*Login Page CSS*/\n.login {\n  position: relative;\n  margin: auto;\n  padding-top: 8rem;\n  /* top: 35px;\n  left: 225px; */\n}\n\n.label_logo {\n  font-size: 17px;\n  font-weight: 800;\n  text-align: center;\n}\n\n.login .signIn {\n  border-radius: 20px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  height: 40px;\n  width: 200px;\n  margin-bottom: 5px;\n}\n\n.login .submit-div {\n  /* margin-left: 100px */\n  text-align: center;\n}\n\n@media screen and (max-width: 768px) {\n  .login {\n    position: absolute;\n    margin: auto;\n  }\n\n  .login .submit-div {\n    /* margin-left: 50px */\n    text-align: center;\n  }\n}\n\n@media screen and (min-width: 992px) and (max-width: 1200px) {\n  .login {\n    position: relative;\n    margin: auto;\n  }\n\n  .login .submit-div {\n    margin-left: 50px;\n  }\n}\n\n@media screen and (min-width: 1200px) and (max-width: 1366px) {\n  .card_new_For_feeReport {\n    border: 1px solid #929baa26;\n    border-radius: 10px;\n    opacity: 1;\n    margin: auto;\n    height: 105px;\n    width: 80px;\n  }\n\n  .payable_heading_feeReport {\n    text-align: center;\n    font: normal normal 8px/10px Montserrat;\n    letter-spacing: 0px;\n    color: white;\n    /* color: #DDDDDD; */\n    opacity: 1;\n  }\n\n  .amount_fee_feeReport {\n    text-align: center;\n    font: normal normal 600 10px/12px Montserrat;\n    letter-spacing: 0px;\n    color: #ffffff;\n    opacity: 1;\n  }\n\n  .months_Name_Report {\n    text-align: center;\n    font: normal normal 650 9px/10px Montserrat;\n    letter-spacing: 0px;\n    color: #ffffff;\n    opacity: 1;\n  }\n\n  .content_feeReport {\n    position: absolute;\n    top: 4px;\n  }\n\n  .widthForTheTR {\n    width: 8rem;\n  }\n\n  .penality_appliad_and_items {\n    color: #0a0a0a;\n    font: normal normal 700 8px/9px Montserrat;\n  }\n\n  .penality_appliad_items {\n    color: #0a0a0a;\n    font: normal normal 700 11px/13px Montserrat;\n  }\n}\n\n@media screen and (min-width: 1367px) and (max-width: 1920px) {\n  .card_new_For_feeReport {\n    border: 1px solid #929baa26;\n    border-radius: 10px;\n    opacity: 1;\n    margin: auto;\n    height: 120px;\n    width: 121px;\n  }\n\n  .months_Name_Report {\n    text-align: center;\n    font: normal normal medium 14px/18px Montserrat;\n    letter-spacing: 0px;\n    color: #ffffff;\n    opacity: 1;\n  }\n\n  .content_feeReport {\n    position: absolute;\n    top: 4px;\n  }\n\n  .widthForTheTR {\n    width: 12rem;\n  }\n\n  .amount_fee_feeReport {\n    text-align: center;\n    font: normal normal 600 12px/15px Montserrat;\n    letter-spacing: 0px;\n    color: #ffffff;\n    opacity: 1;\n  }\n\n  .payable_heading_feeReport {\n    text-align: center;\n    font: normal 10px/12px Montserrat;\n    letter-spacing: 0px;\n    color: white;\n    opacity: 1;\n  }\n\n  .penality_appliad_and_items {\n    color: #0a0a0a;\n    font: normal normal 700 12px/14px Montserrat;\n  }\n\n  .penality_appliad_items {\n    color: #0a0a0a;\n    font: normal normal 700 13px/15px Montserrat;\n  }\n}\n\n/**/\n.card-setting:hover {\n  background: red;\n  color: grey;\n}\n\n.rt-td {\n  overflow: visible;\n}\n\n.button-resize {\n  margin-right: 3%;\n  width: 25px;\n  height: 25px;\n}\n\n.right-border {\n  border-right: 1px solid #ddd;\n}\n\n.card-setting {\n  width: 100%;\n  height: 100px;\n  color: white;\n  cursor: pointer;\n}\n\n.student-info .container {\n  position: relative;\n}\n\n.student-info .container img {\n  display: block;\n  position: relative;\n  border-radius: 50%;\n  background-color: red;\n}\n\n.student-info .container .fonticon-wrap {\n  position: absolute;\n  bottom: 35px;\n  left: 180px;\n  background-color: black;\n  border-radius: 50%;\n  border: 1px white;\n  padding: 10px;\n}\n\n.school-info-account .table {\n  font-size: 16px;\n}\n\n.school-info-account .table .thead tr th {\n  color: #af8eb5;\n  font-size: 16px;\n  font-weight: bold;\n  padding-top: 10px;\n}\n\n.school-info-account .table tr th {\n  color: #7e57c2;\n  font-size: 16px;\n}\n\n.subadmin-btn {\n  background-color: red;\n  color: white;\n  width: 250px;\n  margin-top: 10px;\n}\n\n.subadmin-btn:hover {\n  background-color: red;\n  color: white;\n}\n\n.my-custom-scrollbar {\n  position: relative;\n  height: 200px;\n  overflow-y: scroll;\n}\n\n.table-wrapper-scroll-y {\n  display: block;\n}\n\n.calender-card {\n  height: 35px;\n}\n\n.calender-time-input {\n  padding-top: 20px;\n  text-align: right;\n  float: right;\n  align-items: right;\n}\n\n.Calender-input {\n  width: 48px;\n  border: none;\n  margin-right: 50px;\n}\n\n.Calender-input:active {\n  border: none;\n}\n\n.Calender-input:hover {\n  border: none;\n}\n\n.Calender-input:visited {\n  border: none;\n}\n\n.Organisation {\n  background-color: #e5e8e8;\n  color: #273746;\n  margin-top: 10px;\n  margin-left: 5px;\n  height: 100px;\n}\n\n.Organisation-p {\n  text-align: left;\n  padding-left: 20px;\n  padding-top: 20px;\n  align-items: center;\n}\n\n.Organisation2 {\n  background-color: #e5e8e8;\n  color: #273746;\n  height: 100px;\n  width: 350px;\n}\n\n.Organisation-p2 {\n  text-align: left;\n  padding-left: 20px;\n  padding-top: 20px;\n  align-items: center;\n}\n\n/* .tabs-Report{\n        display: block;\n        align-items: center;\n        text-align: center;\n    } */\n.navitem-report {\n  border: 2px solid red;\n}\n\n.Reset-password-card {\n  align-items: center;\n  text-align: center;\n  padding: 11.6%;\n  background-color: lavender;\n}\n\n.Reset-img {\n  margin-top: 12%;\n  width: 40%;\n  height: auto;\n}\n\n.login-btn {\n  width: 150px;\n  text-align: center;\n  font-size: 13px;\n}\n\n.Forgot-password-card {\n  align-items: center;\n  text-align: center;\n  padding: 16.5%;\n  background-color: lavender;\n}\n\n.forgot-img {\n  margin-top: 5%;\n  width: 50%;\n  height: auto;\n}\n\n.Luxert-Icon {\n  margin-top: 20px;\n}\n\n.More-Card:hover {\n  cursor: pointer;\n}\n\n.dashboard-item-icon {\n  margin-top: 10px;\n  width: 45px;\n  height: auto;\n}\n\n.Pending-text {\n  margin-right: -10px;\n}\n\n@media (max-width: 1460px) {\n  .dashboard-item-col {\n    display: inline-block;\n    justify-content: center;\n    margin-left: 50px;\n    margin-bottom: 10px;\n  }\n}\n\n.heading_school {\n  color: black;\n  font-size: 30px;\n  font-weight: bold;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.branch_school {\n  font-size: 15px;\n  color: white;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.DashBoardCard {\n  font-family: \"Montserrat\", sans-serif;\n  width: 100%;\n  text-align: center;\n  color: black;\n  /* background-color: #7367f0; */\n}\n\n.-improve {\n  font-family: \"Montserrat\", sans-serif;\n  padding: 1rem;\n}\n\n.TransportSubAdmin {\n  font-family: \"Montserrat\", sans-serif;\n  padding-top: 2%;\n  margin: auto;\n  font-size: 18px;\n}\n\n.download-teacher-assest {\n  width: 50px;\n  height: 50px;\n}\n\n.teacher-text {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.Badge-document {\n  width: 150px;\n}\n\n.Nav-emergency {\n  margin-top: 10px;\n}\n\n.Structure {\n  text-align: center;\n}\n\n.Teacher-sections {\n  justify-content: space-between;\n}\n\n.Badge-Badge-ClassCard {\n  width: 90px;\n  height: 25px;\n  padding-top: 8px;\n  background-color: #cdd47b;\n}\n\n.Schedule-View {\n  width: 200px;\n  margin: auto;\n  display: inline-flex;\n  text-align: center;\n}\n\n.Schedule-month {\n  text-align: center;\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 500;\n}\n\n.Schedule-mo {\n  padding-top: 1rem;\n  margin: auto;\n  text-align: center;\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 500;\n}\n\n.Category-General {\n  float: right;\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 500;\n}\n\n.Category-Structure-Name {\n  float: left;\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 500;\n}\n\n.Schedule-Session {\n  margin: auto;\n  text-align: center;\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 700;\n}\n\n.Promote-Acdemic {\n  font-size: 14px;\n  /* text-align: center; */\n  /* margin-left: 25px; */\n}\n\n.Promote {\n  font-size: 15px;\n  height: 2.5rem;\n  width: 6rem;\n  text-align: center;\n  color: black;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.admission_buttons {\n  height: 38px;\n  padding-top: 12px;\n  color: white;\n  width: 140px;\n  border: none;\n}\n\n.carryforward_button {\n  height: 38px;\n  padding-top: 12px;\n  color: white;\n  width: 110px;\n  border: none;\n}\n\n.admission_buttons_Communication {\n  height: 38px;\n  padding: 12px;\n  color: white;\n  width: auto;\n  border: none;\n}\n\n.clientDataStudentButon {\n  height: 37px;\n  padding-top: 12px;\n  font-size: medium;\n  color: white;\n  width: 90px;\n  border: none;\n}\n\n.BackGround_Print {\n  background-color: white;\n}\n\n.feePayment_CardHeader {\n  width: 21.8em;\n  padding-top: 2px;\n  font-family: normal normal 600 14px/18px Montserrat;\n  letter-spacing: 0px;\n  border-radius: 10px 10px 0 0;\n  /* color: #FFFFFF; */\n  text-align: center;\n  color: white;\n  padding-bottom: 5px;\n}\n\n.feePayment_Footter {\n  width: 100%;\n  margin-bottom: 0;\n  padding-top: 2px;\n  font-family: normal normal 600 14px/18px Montserrat;\n  letter-spacing: 0px;\n  border-radius: 0 0 10px 10px;\n  /* color: #FFFFFF; */\n  text-align: center;\n  color: white;\n  padding-bottom: 5px;\n}\n\n.FeeAmount {\n  text-align: right;\n  font: normal 14px/16px Montserrat;\n  letter-spacing: 0px;\n  font-weight: bolder;\n  margin-top: 0.3rem;\n  margin-right: 0.5rem;\n  color: #000000;\n  opacity: 1;\n}\n\n.FeeText {\n  text-align: left;\n  font: normal 14px/18px Montserrat;\n  letter-spacing: 0px;\n  margin-top: 0.3rem;\n  margin-left: 0.5rem;\n  font-weight: bold;\n  color: #707070;\n  opacity: 1;\n}\n\n.feePayment_Cards {\n  border-radius: 10px;\n  border: 3px solid red;\n  background-color: #f7f7f7;\n  margin: auto;\n  box-sizing: border-box;\n  border: 1px solid #929baa26;\n  /* align-items: center; */\n  box-shadow: 0px 5px 15px #00000014;\n  opacity: 1;\n  justify-self: center;\n  justify-content: center;\n}\n\n.AmountCollectedCard {\n  background-color: #11242c;\n  color: white;\n  text-align: center;\n  height: 80px;\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n  border-radius: 1rem;\n}\n\n.cashdateRange {\n  background-color: green;\n  color: white;\n}\n\n.chequedateRange {\n  background-color: purple;\n  color: white;\n}\n\n.bankdateRange {\n  background-color: skyblue;\n  color: white;\n}\n\n.onlinedateRange {\n  background-color: orange;\n  color: white;\n}\n\n.ChequeCollection {\n  font-size: x-small;\n  text-align: center;\n}\n\n.MinimumDueAmount {\n  width: 150px;\n  margin: auto;\n  border-radius: 20px;\n  height: calc(1.66rem + 1px) !important;\n  font-size: 0.675rem;\n}\n\n.monthSelect {\n  width: 150px;\n  align-items: right;\n  /* margin-right:5px ; */\n  border-radius: 20px;\n  height: calc(1.86rem + 12px) !important;\n  font-size: 1rem;\n}\n\n.glow_border {\n  background-color: black;\n}\n\n/* .glow {\n  font-size: 20px;\n  color: #fff;\n  text-align: center;\n  -webkit-animation: glow 1s ease-in-out infinite alternate;\n  -moz-animation: glow 1s ease-in-out infinite alternate;\n  animation: glow 1s ease-in-out infinite alternate;\n}\n\n@-webkit-keyframes glow {\n  from {\n    text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #e60073, 0 0 40px #e60073, 0 0 50px #e60073, 0 0 60px #e60073, 0 0 70px #e60073;\n  }\n\n  to {\n    text-shadow: 0 0 20px #fff, 0 0 30px #ff4da6, 0 0 40px #ff4da6, 0 0 50px #ff4da6, 0 0 60px #ff4da6, 0 0 70px #ff4da6, 0 0 80px #ff4da6;\n  }\n} */\n\n.AddExam_Periodic {\n  background: burlywood;\n}\n\n.Table_Header {\n  text-align: center;\n  margin-top: 3em;\n}\n\n.Teacher_Attendance_Report {\n  text-align: center;\n  margin-left: 20rem;\n}\n\n.Teacher_Attendance_Report_text {\n  font-size: 2rem;\n}\n\n.Teacher_Attendance_Card_Report {\n  color: #7e57c2;\n}\n\n.Employee_OutTime {\n  width: 30rem;\n}\n\n.Result_List {\n  padding-top: 1em;\n  border-radius: 8%;\n  padding-left: 1em;\n  width: 10em;\n  box-shadow: floralwhite 5px 5px 5px 5px;\n}\n\n.studentTableSubject {\n  align-items: center;\n  text-align: center;\n}\n\n.StudentTable {\n  background-color: #7367f0;\n  color: white;\n}\n\n.promotestudentTable {\n  align-items: center;\n  color: \"#0A0A0A\";\n  font-weight: 800;\n  text-align: center;\n}\n\n.pdf_header {\n  text-align: center;\n  align-items: center;\n}\n\n.pdf_fontFamily {\n  font-family: Georgia, \"Times New Roman\", Times, serif;\n}\n\n.printComponent {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: medium;\n  font-weight: 500;\n  text-transform: uppercase;\n  margin-top: 5rem;\n  text-align: center;\n}\n\n.my-Promote-Student {\n  position: relative;\n  height: 400px;\n  overflow-y: scroll;\n}\n\n.DailyReportTable {\n  position: relative;\n  height: 380px;\n  overflow-y: scroll;\n  text-align: center;\n}\n\n.incomeTableHandling {\n  position: relative;\n  height: 200px;\n  overflow-y: scroll;\n  text-align: center;\n}\n\n.ExpenditureTableHandling {\n  position: relative;\n  height: 270px;\n  overflow-y: scroll;\n  text-align: center;\n}\n\n.leaveMangementclassDailyReport {\n  position: relative;\n  height: 280px;\n  overflow-y: scroll;\n  text-align: cent;\n}\n\n.classBulkAttendanceTable {\n  position: relative;\n  /* height: 380px; */\n  overflow-x: scroll;\n  text-align: center;\n}\n\n.table-Promote {\n  display: block;\n}\n\n/* ------------ template css  ------------*/\n\n.template-row {\n  padding: 120px 0px;\n  margin: auto;\n  justify-content: center;\n  text-align: center;\n  font-size: 30px;\n  color: #000000;\n  font-weight: 700;\n  font-family: Montserrat, sans-serif;\n}\n\n.template {\n  box-shadow: 10px 10px 10px 10px #f5f5f5;\n  margin: auto;\n  width: 1000px;\n  margin-bottom: 100px;\n}\n\n.tempalte-image {\n  width: 150px;\n}\n\n.template-button {\n  margin-bottom: 20px;\n  background-color: #3acce1;\n  width: 450px;\n  border-radius: 7px;\n  border: none;\n}\n\n.template-button:hover {\n  background-color: #3acce1;\n}\n\n.template-body h4 {\n  color: #ff0000;\n  font-weight: 700;\n}\n\n.template-buttonTwo {\n  background-color: #cacaca;\n  width: 450px;\n  border-radius: 7px;\n  border: none;\n}\n\n.template-buttonTwo:hover {\n  background-color: #cacaca;\n}\n\n.tempalte-p {\n  margin-top: 10px;\n  font-size: 10px;\n  color: #0e172c;\n}\n\n.template-h6 {\n  font-size: 15px;\n  margin-bottom: 15px;\n}\n\n.lock-template {\n  margin-right: 5px;\n  width: 8px;\n  height: 12px;\n}\n\n.paymentImage {\n  margin: auto;\n  text-align: center;\n}\n\n.paymentcol {\n  margin: auto;\n  text-align: center;\n}\n\n/* Employee_List */\n\n.Employee_List {\n  margin-left: 5rem;\n}\n\n/* dashboard subaadmin */\n\n.divider {\n  border-left: 2px solid #e3e3e3;\n  opacity: 1;\n  height: 90px;\n  margin: auto;\n}\n\n.card_img_new {\n  margin-left: 1.4rem;\n  margin-top: 0.5rem;\n  width: 55px;\n  height: 57px;\n}\n\n.amount {\n  text-align: center;\n  font: normal normal 600 18px/22px Montserrat;\n  letter-spacing: 0px;\n  color: #000000;\n  opacity: 1;\n}\n\n.text_card_sub {\n  text-align: center;\n  font: normal normal medium 12px/16px Montserrat;\n  letter-spacing: 0px;\n  color: #000000;\n  opacity: 1;\n}\n\n.amount_text_Col_Subadmin {\n  margin: auto;\n  padding: auto;\n}\n\n.card_sunadmin_dashboard {\n  background: #ffffff 0% 0% no-repeat padding-box;\n  box-shadow: 0px 10px 10px #00000029;\n  border-radius: 10px;\n  opacity: 1;\n  text-align: center;\n  justify-content: center;\n}\n\n.label_card_subadmin {\n  text-align: center;\n  font: normal normal 500 12px/16px Montserrat;\n  letter-spacing: 0.5px;\n  opacity: 1;\n  margin-right: -2.7rem;\n  margin-top: 0.5rem;\n}\n\n/* side table --start  */\n\n.UpComingExam_SubAdmin {\n  background: #ffffff 0% 0% no-repeat padding-box;\n  border: 1px solid #e2e2e2;\n  border-radius: 10px;\n  opacity: 1;\n  height: 18.5rem;\n}\n\n.upcoming_exam_table {\n  background: #7164ff 0% 0% no-repeat padding-box;\n  border-radius: 10px 10px 0px 0px;\n  opacity: 1;\n  margin: auto;\n  font: normal normal 600 20px/24px Montserrat;\n  letter-spacing: 0px;\n  color: #ffffff;\n  opacity: 1;\n  height: 3.5rem;\n}\n\n.table_header_upcoming {\n  background: #f7f7f7 0% 0% no-repeat padding-box;\n  border: 1px solid #e2e2e2;\n  opacity: 1;\n}\n\n.table_text {\n  text-align: center;\n  font: normal normal 600 14px/18px Montserrat;\n  letter-spacing: 0px;\n  color: #000000;\n  opacity: 1;\n}\n\n.table_body_upcoming {\n  background: #ffffff 0% 0% no-repeat padding-box;\n  box-shadow: 0px 1px 20px #00000017;\n  border: 1px solid #e2e2e2;\n  border-radius: 10px;\n  opacity: 1;\n}\n\n.table_body_text {\n  text-align: center;\n  font: normal normal medium 14px/18px Montserrat;\n  letter-spacing: 0px;\n  color: #000000;\n  opacity: 1;\n}\n\n/* side table --end */\n\n/* reponsive ----css */\n@media (max-width: 1460px) {\n  .card_img_new {\n    margin-left: 1.4rem;\n    margin-top: 0.5rem;\n    width: 35px;\n    height: 37px;\n  }\n\n  .amount {\n    text-align: center;\n    font: normal normal 600 12px/15px Montserrat;\n    letter-spacing: 0px;\n    margin-left: 2rem;\n    color: #000000;\n    opacity: 1;\n  }\n\n  .divider {\n    border-left: 2px solid #e3e3e3;\n    opacity: 1;\n    height: 70px;\n    margin: auto;\n  }\n\n  .text_card_sub {\n    text-align: center;\n    font: normal normal 500 12px/16px Montserrat;\n    letter-spacing: 0px;\n    color: #000000;\n    margin-left: 2rem;\n    opacity: 1;\n  }\n\n  .label_card_subadmin {\n    text-align: center;\n    font: normal normal 500 10px/14px Montserrat;\n    letter-spacing: 0.5px;\n    opacity: 1;\n    margin-right: -2.7rem;\n    margin-top: 0.5rem;\n  }\n}\n\n@media (max-width: 1000px) {\n  .divider {\n    display: none;\n  }\n\n  .text_card_sub {\n    text-align: center;\n    font: normal normal 500 14px/20px Montserrat;\n    letter-spacing: 0px;\n    color: #000000;\n    margin-left: 5rem;\n    opacity: 1;\n  }\n\n  .amount {\n    text-align: center;\n    font: normal normal 600 17px/24px Montserrat;\n    letter-spacing: 0px;\n    margin-left: 5rem;\n    margin-top: 2rem;\n    color: #000000;\n    opacity: 1;\n  }\n\n  .card_img_new {\n    margin-left: 1.4rem;\n    margin-top: 0.5rem;\n    width: 55px;\n    height: 57px;\n  }\n\n  .label_card_subadmin {\n    text-align: center;\n    font: normal normal 500 14px/20px Montserrat;\n    letter-spacing: 0.5px;\n    opacity: 1;\n    margin-right: -2.7rem;\n    margin-top: 0.5rem;\n  }\n}\n\n.table_heading {\n  text-align: center;\n  color: black;\n}\n\n/* lef hand css == -= -=-=  */\n.report_schoolName {\n  font-size: 18px;\n  font-weight: 900;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.reportSchoolName {\n  font-size: 27px;\n  font-weight: 900;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.STUDENTREPORTSCHOOLNAME {\n  font-size: 30px;\n  font-weight: 900;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.schoolCode {\n  text-align: right;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.SCHOOLCODE {\n  text-align: right;\n  font-size: 27px;\n  font-weight: 600;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.reportSchoolCde {\n  text-align: right;\n  font-size: 22px;\n  font-weight: 600;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.relativeCSS {\n  border: solid 1px #ff0000;\n  padding: \"2rem\";\n  margin-left: \"2rem\";\n  margin-right: \"2rem\";\n}\n\n.affiliationNo {\n  text-align: right;\n  font-size: 16px;\n  font-weight: 900;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.AFFLICATIONREPORTSTUDENT {\n  text-align: right;\n  font-size: 30px;\n  font-weight: 900;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.studentAffiliationNo {\n  text-align: right;\n  font-size: 22px;\n  font-weight: 900;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.report_Tag {\n  font-size: 14px;\n  font-weight: 600;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.REPORTTAG {\n  font-size: 27px;\n  font-weight: 600;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.branchNameReport {\n  font-size: 22px;\n  font-weight: 600;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.report_Address {\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 0.1rem;\n  font-family: \"Montserrat\", sans-serif;\n  color: #000000;\n}\n\n.REPORTADRESSS {\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0.1rem;\n  font-family: \"Montserrat\", sans-serif;\n  color: #000000;\n}\n\n.addressReportStudent {\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 0.1rem;\n  font-family: \"Montserrat\", sans-serif;\n  color: #000000;\n}\n\n.report_Branch {\n  font-size: 14px;\n  font-weight: 900;\n  font-family: \"Montserrat\", sans-serif;\n  color: #312a2a;\n}\n\n.REPORTbRANCCH {\n  font-size: 24px;\n  font-weight: 900;\n  font-family: \"Montserrat\", sans-serif;\n  color: #312a2a;\n}\n\n/* ------------------------ */\n.modal_item_alignment {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 30px;\n  font-weight: 600;\n  text-align: center;\n  margin: auto;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal_item {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 22px;\n  font-weight: 600;\n  text-align: center;\n  margin: auto;\n  align-items: center;\n  justify-content: center;\n}\n\n/* end dashboard */\n\n.feeRecipt_Admission_Student {\n  font-size: 14px;\n  color: black;\n  font-weight: 500;\n}\n\n.feeRecipt_Admission_stuNumber {\n  font-size: 14px;\n  color: black;\n  font-weight: 500;\n}\n\n.TooltipAlignMent {\n  text-align: right;\n  margin-right: 1rem;\n  height: auto;\n  width: auto;\n}\n\n.vertical_line_between {\n  border-left: 2px solid black;\n  height: 25px;\n  position: absolute;\n  left: 50%;\n}\n\n.table_student_report {\n  border-radius: 10px 10px;\n}\n\n/* time -table - ui section  */\n.time_table_daysPeriods {\n  background: rgb(157, 150, 150) 0% 0% no-repeat padding-box;\n  border-radius: 3px;\n  /* opacity: 0.2; */\n}\n\n.days_text_timeTable {\n  text-align: center;\n  font: normal normal 600 12px/14px Montserrat;\n  letter-spacing: 0px;\n  color: white;\n  /* opacity: ; */\n}\n\n.time_table_periodTime {\n  background: #ffffff 0% 0% no-repeat padding-box;\n  border-radius: 3px;\n  opacity: 1;\n  padding-top: 15px;\n  width: 100%;\n  height: 50px;\n}\n\n.time_table_subject {\n  background: #ffffff 0% 0% no-repeat padding-box;\n  border-radius: 3px;\n  opacity: 1;\n  width: auto;\n  padding-top: 5px;\n  padding-left: 9px;\n  height: 70px;\n  text-align: left;\n}\n\n.time_table_Crole {\n  position: relative;\n  overflow-x: scroll;\n}\n\n.subjectTimeTable {\n  text-align: left;\n  font: normal normal 600 12px/14px Montserrat;\n  letter-spacing: 0px;\n  color: white;\n  opacity: 1;\n}\n\n.timetableBreakTime {\n  background: #f8f8f8 0% 0% no-repeat padding-box;\n  color: white;\n  /* opacity: 1; */\n}\n\n.timeTableBreak {\n  background: rgb(179, 169, 169) 0% 0% no-repeat padding-box;\n  border-radius: 3px;\n  color: white;\n  /* opacity: 0.2; */\n}\n\n.breaktimetableText {\n  text-align: center;\n  font: normal normal 600 12px/14px Montserrat;\n  letter-spacing: 0px;\n  color: white;\n  opacity: 1;\n}\n\n.timeTableAssembly {\n  background: #f8f8f8 0% 0% no-repeat padding-box;\n  /* opacity: 1; */\n}\n\n.assTimeTable {\n  background: rgb(139, 135, 135) 0% 0% no-repeat padding-box;\n  border-radius: 3px;\n  /* opacity: 0.2; */\n}\n\n.assmTimeTableText {\n  text-align: left;\n  font: normal normal 600 12px/14px Montserrat;\n  letter-spacing: 0px;\n  color: white;\n  /* opacity: 1; */\n}\n\n.AddTIMETABLEDAYS {\n  background: rgb(184, 175, 175) 0% 0% no-repeat padding-box;\n  border-radius: 3px;\n  text-align: center;\n  /* opacity: 0.2; */\n}\n\n.ADDTIMETABLEPERIODSDAYS {\n  text-align: center;\n  font: normal normal 600 12px/14px Montserrat;\n  letter-spacing: 0px;\n  color: white;\n  /* opacity: 1; */\n}\n\n.AssemblyTime {\n  background: #f5f5f5 0% 0% no-repeat padding-box;\n  /* opacity: 1; */\n}\n\n.AssemblyText {\n  text-align: center;\n  font: normal normal 600 12px/14px Montserrat;\n  letter-spacing: 0px;\n  color: white;\n  /* opacity: 1; */\n}\n\n.AssemblyTextBackground {\n  background: rgb(165, 157, 157) 0% 0% no-repeat padding-box;\n  border-radius: 3px;\n  /* opacity: 0.2; */\n}\n\n.periodTime {\n  background: #ffffff 0% 0% no-repeat padding-box;\n  border-radius: 3px;\n  text-align: center;\n  padding-top: 15px;\n  width: auto;\n  height: 50px;\n}\n\n/* time - table - ui section end  */\n\n/* new one Extre */\n\n.ExpnedutureCard {\n  font-size: 10px;\n  color: white;\n  background-color: #012d47;\n  color: white;\n  text-align: center;\n  font-weight: 900;\n  text-transform: uppercase;\n}\n\n.studentInfoTOOLSpATENT {\n  font: normal normal 700 12px/14px Montserrat;\n  color: #0a0a0a;\n}\n\n.cardForPaymentList {\n  width: 100%;\n  height: auto;\n  border-radius: 1rem;\n  margin: 1rem;\n  color: white;\n  font: normal normal 700 14px/16px Montserrat;\n  padding: 2.5rem;\n  align-items: center;\n  text-align: center;\n}\n\n.cardForPaymentList_card {\n  width: 100%;\n  height: 2.6rem;\n  border-radius: 1rem;\n  margin: 0.5rem;\n  margin-top: 0.9rem;\n  margin-left: 1.3rem;\n  color: white;\n  font: normal normal 700 12px/16px Montserrat;\n  padding: 0.9rem;\n  align-items: center;\n  text-align: center;\n}\n\n.button_spacial {\n  width: 12rem;\n  height: 4.9rem;\n}\n\n.Registration_report_cards {\n  height: 100%;\n  width: 100%;\n  border-radius: 1rem;\n  font: normal normal 700 12px/16px Montserrat;\n  text-align: center;\n  padding-top: 2.6rem;\n  padding-bottom: 2rem;\n}\n\n.Regis_report_card {\n  height: 2.6rem;\n  width: 100%;\n  border-radius: 1rem;\n  font: normal normal 700 10px/12px Montserrat;\n  text-align: center;\n  padding-top: 1rem;\n  margin-top: 0.5rem;\n  padding-bottom: 2rem;\n}\n\n.paymentModalClassForChange {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 30px;\n  font-weight: 600;\n  text-align: center;\n  margin: auto;\n  align-items: center;\n  justify-content: center;\n}\n\n.paymentMessageFromProps {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 22px;\n  font-weight: 600;\n  text-align: center;\n  margin: auto;\n  align-items: center;\n  justify-content: center;\n}\n\n.finalModalClassForChange {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 30px;\n  font-weight: 600;\n  text-align: center;\n  margin: auto;\n  align-items: center;\n  justify-content: center;\n}\n\n.finalClassForChange {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  text-align: center;\n  margin: auto;\n  align-items: center;\n  justify-content: center;\n}\n\n.custom-calendar {\n  /* Custom styles for the calendar */\n  .react-calendar.react-calendar--border {\n    border: none !important;\n    /* Remove border */\n  }\n\n  /* Increase font size and weight of the month */\n  .react-calendar__navigation__label {\n    font-size: 18px;\n    font-weight: bold;\n    color: purple !important;\n  }\n\n  /* Custom styles for react-calendar */\n  .react-calendar {\n    /* Remove border */\n    border: none;\n  }\n\n  /* Increase font size and weight for calendar dates */\n  .react-calendar__month-view__days__day {\n    font-size: 15px;\n    font-weight: 700;\n    text-decoration: none;\n  }\n\n  .react-calendar__month-view__weekdays__weekday {\n    font-size: 13px;\n    font-weight: bold;\n    text-decoration: none !important;\n    color: black !important;\n  }\n\n  /* Remove default border styles for all tiles */\n  .react-calendar__tile {\n    border: none !important;\n  }\n\n  /* Responsive styles */\n}\n\n@media (max-width: 768px) {\n  .custom-calendar {\n    width: 100%;\n  }\n}\n\n.transport-fee-button {\n  font-size: 1.2rem;\n  height: 2.5rem;\n  background-color: red;\n  text-align: center;\n  width: auto; /* Allow width to adjust based on content */\n  min-width: 30%; /* Minimum width */\n  margin-left: 1em;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0.5em; /* Adjust padding to manage space */\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  transition: width 0.2s ease, font-size 0.2s ease; /* Smooth transition for width and font-size */\n}\n\n.transport-fee-button .bus-image {\n  width: auto;\n  height: 100%;\n  margin-right: 0.5em; /* Add some space between image and text */\n}\n\n.transport-fee-button .transport-fee-text {\n  flex: 1;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  display: inline-block;\n}\n\n@media (max-width: 1200px) {\n  .transport-fee-button {\n    font-size: 1rem; /* Decrease font size for smaller screens */\n  }\n}\n\n@media (max-width: 992px) {\n  .transport-fee-button {\n    font-size: 0.9rem; /* Further decrease font size for smaller screens */\n  }\n}\n\n@media (max-width: 768px) {\n  .transport-fee-button {\n    font-size: 0.8rem; /* Further decrease font size for smaller screens */\n    width: 80%; /* Adjust width to be more flexible */\n  }\n}\n\n@media (max-width: 576px) {\n  .transport-fee-button {\n    font-size: 0.7rem; /* Further decrease font size for smallest screens */\n    width: 100%; /* Full width for smallest screens */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
